import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_MODULE } from '../../../../Constants';
import { toast } from 'react-toastify';

export const useUpsertLessons = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const upsertLessonsHook = async (moduleId, lessons, handleUpdates) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_MODULE}/${moduleId}/lessons`,
        {lessons: lessons}
      );

      const status = response?.status;
      if (status === 200) {
        setSuccess(true);
        toast.success(`Lessons creating/updating successful.`, {
                position: toast.POSITION.BOTTOM_LEFT
        });
        handleUpdates()
      } else {
        setError("Failed to create/update lessons");
      }
    } catch (error) {
      setError("An error occurred while creating/updating lessons");
    } finally {
      setLoading(false);
    }
  };

  return [ upsertLessonsHook, loading, error, success ];
};